import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Music, Lock, ArrowRight, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { errText } from '../api';

export default function ResetPassword() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { resetPassword } = useAuth();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const token = params.get('token');

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error('Passwords don\u2019t match.'); return; }
    setBusy(true);
    try {
      const user = await resetPassword(token, pw);
      toast.success('Password updated. You\u2019re signed in.');
      nav(user.role === 'studio' ? '/studio' : '/dashboard');
    } catch (err) { toast.error(errText(err, 'Could not reset your password.')); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-ink grain grid place-items-center px-6">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-3 mb-10">
          <span className="grid place-items-center w-10 h-10 rounded-full border hairline"><Music size={16} className="text-gold" /></span>
          <span className="font-display text-lg text-cream">Brand <span className="italic text-gold-grad">Melody</span></span>
        </Link>
        <p className="eyebrow mb-3">Account</p>
        <h1 className="font-display text-4xl text-cream mb-6">Choose a new password.</h1>
        {!token ? (
          <p className="text-cream/60" data-testid="reset-missing">This link is missing its token. <Link to="/signin" className="text-gold hover:underline">Request a new one</Link>.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
            <div className="flex items-center gap-3 rounded-xl border hairline px-4 py-3 focus-within:border-gold/50 transition-colors"><Lock size={17} className="text-gold/70" /><input type="password" required minLength={8} placeholder="New password (8+ characters)" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password" className="bg-transparent flex-1 outline-none text-cream placeholder:text-cream/35" /></div>
            <div className="flex items-center gap-3 rounded-xl border hairline px-4 py-3 focus-within:border-gold/50 transition-colors"><Lock size={17} className="text-gold/70" /><input type="password" required minLength={8} placeholder="Repeat new password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-2" className="bg-transparent flex-1 outline-none text-cream placeholder:text-cream/35" /></div>
            <button type="submit" disabled={busy} data-testid="reset-submit" className="w-full btn-gold rounded-full py-3.5 flex items-center justify-center gap-2 disabled:opacity-70">{busy ? <Loader2 size={17} className="animate-spin" /> : <>Save password <ArrowRight size={17} /></>}</button>
          </form>
        )}
      </div>
    </div>
  );
}
